import React from 'react';
import classNames from 'classnames';

import ZpButton from 'components/zpButton';
import { scrollTo } from 'utils';

import classes from './pageSectionNavigation.module.css';

interface IProps {
  sections: {
    id: string; // id of the section container element
    url: string; // url of the link, this will mostly be the the url of the page
    title: string; // title of the link
    onLinkClick?: () => void; // click handler of the link
    renderButton?: boolean; // Render a button instead of an anchor link.
  }[];
}

const PageSectionNavigation = ({ sections }: IProps) => (
  <>
    <ul className="nav">
      {sections.map(({ id, url, title, onLinkClick, renderButton }) => (
        <li key={id} className={classNames('position-relative mb-1 mb-md-0 mr-4', classes.navItm)}>
          {renderButton ? (
            <ZpButton onClick={onLinkClick || (() => scrollTo(id, 500))} theme="link" size="big">
              {title}
            </ZpButton>
          ) : (
            <a
              href={`${url}#${id}`}
              onClick={onLinkClick || (() => null)}
              className="text-capitalize alink font-weight-600"
            >
              {title}
            </a>
          )}
        </li>
      ))}
    </ul>
  </>
);

export default PageSectionNavigation;
